<template>
  <chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import Chart from '@/components/charts/Chart'

export default {
  name: 'QuantityShippedAverageSalesChart',
  components: {
    Chart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    report: {
      type: Array,
      default: null
    },
    labelField: {
      type: String,
      default: 'date'
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.report.map(item => item[this.labelField]),
        datasets: [
          {
            type: 'line',
            label: '平均売価',
            borderWidth: 2,
            fill: false,
            data: this.report.map(item => item.averageSales),
            tension: 0.4,
            yAxisID: 'lineChart'
          },
          {
            type: 'bar',
            label: '発送済み商品数',
            borderWidth: 2,
            fill: false,
            data: this.report.map(item => item.quantityShipped),
            yAxisID: 'barChart'
          }
        ]
      }
    },
    options () {
      return {
        plugins: {
          legend: {
            display: true,
            reverse: true
          },
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                const label = tooltipItem.dataset.label
                const value = tooltipItem.formattedValue
                if (label === '平均売価') {
                  return `${label}: \xA5${value}`
                }
                return `${label}: ${value}`
              }
            }
          }
        },
        maintainAspectRatio: false,
        scales: {
          barChart: {
            stacked: false,
            suggestedMin: 0
          },
          lineChart: {
            stacked: false,
            position: 'right',
            suggestedMin: 0,
            ticks: {
              callback (value) {
                return `\xA5${value.toLocaleString()}`
              }
            }
          }
        }
      }
    }
  }

}
</script>

<style scoped>
</style>
